import script from "./RuleSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./RuleSetting.vue?vue&type=script&lang=ts&setup=true"

import "./RuleSetting.vue?vue&type=style&index=0&id=17ec58c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ec58c6"]])

export default __exports__